import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import chefPhoto from "../assets/img/chef-departement.jpeg";

export default function MessageChefDepartement() {
  const [isExpanded, setIsExpanded] = useState(true);

  const message = `Ry tanora malala, 

Isaorana Andriamanitra izay nanome antsika ity plateforme ity hianarana sy hiofanana. 

Ny lalam-piofanana Chef Guide sy Senior Youth Leader dia tsy fiofanana fotsiny, fa antso sy fanamasinana ho amin'ny andraikitra lehibe amin'ny fitarihana sy ny fanompoana ny tanora ao amin'ny fiangonana mba hanofana sy ny hitarika ny tanora ho amin'ny fahamatorana, ny fahatokiana amin'Andriamanitra, ary ny fahavononana hizara ny filazantsara amin'ny fomba mafonja sy azo tsapain-tanana. 

Manombok'eto dia hianatra ise, tsy ny teoria ihany, fa indrindra ny fomba fiaina maha-mpanompon'i Kristy, ny etika amin'ny fitarihana, ny fahaiza-mitarika, ary ny fanompoana madio mandrakariva.

Ity fiofanana ity no hanamafy ny fiantsoana an'ise ho mpiaro sy mpitari-dalana, ho modely ho an'ny tanora sy ny ankizy, ary ho lasa fitaovan'ny Fanahy Masina eo amin'ny fiangonana sy ny fiarahamonina misy an'ise. 

Koa asaina ise hanokatra fo, hanokatra saina, ary hanolo-tena feno ho an'Andriamanitra mandritra ny lalam-piofanana, satria ny asa fanompoan'ny tanora dia sehatra lehibe itarihantsika ny tanora ho amin'ny famonjena.

Enga anie ity fiofanana ity hitondra fitomboana, fahendrena, fifankahazoana ary fifohazana ara-panahy ho an'ny mpiofana tsirairay ary ho an'ny asa fanompoana rehetra.

Ho an'Andriamanitra irery anie ny voninahitra.

Pasteur RAKOTOMALALA Mijo Tsiry
Chef ZORILLE HARDI
Talen'ny Departemantan'ny Asa fanompoan'ny Tanora Advantista
FEDERASIONA MADAGASIKARA AFOVOANY`;

  return (
    <div className="card border-0 shadow-lg mb-5" style={{ backgroundColor: "#ffffff", borderRadius: "15px" }}>
      <div 
        className="card-header d-flex justify-content-between align-items-center"
        style={{ 
          backgroundColor: "#0d6efd", 
          color: "white",
          cursor: "pointer",
          borderRadius: "15px 15px 0 0",
          padding: "1.25rem"
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="d-flex align-items-center">
          <i className="bi bi-megaphone-fill me-2 me-md-3" style={{ fontSize: "1.2rem" }}></i>
          <h5 className="mb-0 fw-bold" style={{ fontSize: "clamp(0.9rem, 2.5vw, 1.25rem)" }}>
            <span className="d-none d-md-inline">Message du Chef de Département de la Jeunesse Adventiste</span>
            <span className="d-md-none">Message du Chef</span>
          </h5>
        </div>
        <i className={`bi bi-chevron-${isExpanded ? "up" : "down"}`} style={{ fontSize: "1.5rem" }}></i>
      </div>
      
      {isExpanded && (
        <div className="card-body p-4">
          <div className="row">
            <div className="col-md-4 col-lg-3 text-center mb-4 mb-md-0">
              <img
                src={chefPhoto}
                alt="Chef ZORILLE HARDI"
                className="img-fluid rounded shadow"
                style={{ 
                  maxHeight: "350px", 
                  width: "100%",
                  objectFit: "cover",
                  border: "3px solid #0d6efd"
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
              <p className="mt-3 mb-0 fw-semibold text-primary">Chef ZORILLE HARDI</p>
              <p className="text-muted small">Talen'ny Departemantan'ny Asa fanompoan'ny Tanora Advantista</p>
            </div>
            <div className="col-md-8 col-lg-9">
              <div 
                className="text-justify"
                style={{ 
                  whiteSpace: "pre-line",
                  lineHeight: "1.9",
                  fontSize: "1rem",
                  color: "#2c3e50"
                }}
              >
                {message}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
